module.exports = __webpack_public_path__ + "img/screenshot.81d5fffc.svg";